import { Card } from "@/src/components/wrappers/Card";
import { Booking } from "../../model";
import { Button } from "@/src/components/ui/button";
import { useState } from "react";
import { EditBookingNotesModal } from "../../EditBookingNotes";

const InternalNotesSection = ({ booking }: { booking: Booking }) => {
  const [updateInternalNotesOpen, setUpdateInternalNotesOpen] = useState(false);

  return (
    <Card className="w-full flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Internal notes</h3>
        <Button
          onClick={() => {
            setUpdateInternalNotesOpen(true);
          }}
          variant="link"
        >
          Edit
        </Button>{" "}
      </div>
      <ul>
        {!!booking.brokerNotes?.length ? (
          booking.brokerNotes?.map((note: string) => <li>{note}</li>)
        ) : (
          <span>No notes here</span>
        )}
      </ul>
      {updateInternalNotesOpen && (
        <EditBookingNotesModal
          open={updateInternalNotesOpen}
          setOpen={setUpdateInternalNotesOpen}
          initialNotes={booking?.brokerNotes || []}
          bookingId={booking?.id}
        />
      )}
    </Card>
  );
};

export default InternalNotesSection;
